import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import AnalysisMenu from './AnalysisMenu.vue'
import { store } from '@/store';
import { time } from '@/utils/time';
import { Globe, Layer, tile } from '@hscmap/stellar-globe';
import { StellarGlobeTileLayer } from '@/stellar-globe-components/tile_layer_component_base';


@Component
export class JupyterModule extends Mixins(ModuleBase) {
  get outlet() {
    return {
      analysisMenu: AnalysisMenu,
    }
  }

  created() {
    this.$nextTick(async () => {
      await waitFor(() => !!this.getGlobe())
    })
  }

  getGlobe() {
    return store.globe(store.jupyterFrame!)!
  }
}

async function waitFor(check: () => boolean) {
  while (!await check()) {
    await time.sleep(0)
  }
}

export function waitForImageLoad(globe: Globe) {
  return new Promise((resolve) => {
    // @ts-ignore
    globe.draw()
    if (numLoadingImages(globe) == 0) {
      resolve()
    }
    const listener = () => {
      if (numLoadingImages(globe) == 0) {
        globe.ee.off('imageloadend', listener)
        resolve()
      }
    }
    globe.ee.on('imageloadend', listener)
  })
}

export function numLoadingImages(globe: Globe) {
  let n = 0
  globe.eachLayer((l: Layer) => {
    if (l instanceof StellarGlobeTileLayer && l.tp instanceof tile.AsyncTextureProvider) {
      // @ts-ignore
      n += l.tp.numLoadingImages()
    }
  })
  return n
}